<i class="fa-solid fa-circle-info info-icon" (click)="showMessage()"></i>
